import type { CustomIndustryResult } from "app/services/industryAnalysis/customIndustryAgentService";

import { AGENT_STEPS } from "../../CustomHooks/customIndustryAgent.types";

/** How many steps are done once the named node has reported, so reordering `AGENT_STEPS`
 *  moves these with it instead of silently pointing at a different node. */
const stepsThrough = (step: (typeof AGENT_STEPS)[number]): number => AGENT_STEPS.indexOf(step) + 1;

/** The result carries the industry from `publish_assets` on, so a run that is still busy
 *  with it is on `warm_overview`. */
export const inferCompletedStepsFromResult = (result: CustomIndustryResult): number => {
    if (result.industryId) {
        return stepsThrough("publish_assets");
    }

    if (result.segmentCount > 0) {
        return stepsThrough("create_segments");
    }

    if (result.domainCount > 0) {
        return stepsThrough("classify_domains");
    }

    return 0;
};
